import { OktaAuth, type UserClaims } from '@okta/okta-auth-js';
import { ContainerInstance, Service } from 'typedi';
import { type AppEnvironment } from '../config/app-environment';
import { EnvironmentService } from '../config/environment.service';
import { AppRoute } from '../routes';
import { SettingsService } from './settings';

export type CcmUserClaims = UserClaims<{
  contactUID: string;
  groups: string[];
}>;

@Service()
export class OktaService {
  readonly oktaAuth: OktaAuth;

  constructor(container: ContainerInstance) {
    const { environment } = container.get(EnvironmentService<AppEnvironment>);
    const { settings } = container.get(SettingsService);

    this.oktaAuth = new OktaAuth({
      clientId: environment.VITE_APP_PRAYER_STREAM_OKTA_CLIENT_ID,
      devMode: settings.enableOktaLogging,
      issuer: environment.VITE_APP_PRAYER_STREAM_OKTA_ISSUER,
      pkce: true,
      postLogoutRedirectUri: `${globalThis.location.origin}${AppRoute['/login']}`,
      redirectUri: `${globalThis.location.origin}${AppRoute['/login/callback']}`,
      scopes: ['openid', 'profile', 'email', 'offline_access'],
      services: {
        autoRemove: false,
        autoRenew: false,
      },
      tokenManager: {
        autoRenew: true,
        expireEarlySeconds: 30,
        storage: 'memory',
      },
    });
  }

  async getAccessToken(): Promise<string | null> {
    try {
      const accessToken = await this.oktaAuth.getOrRenewAccessToken();
      return accessToken;
    } catch {
      return null;
    }
  }
}
